// extracted by mini-css-extract-plugin
export default {"root":"AnimeList_root__fkpg8"};